/** Global web app branding — used for document title, manifest, meta tags. */
export const APP_NAME = 'Healthy Pet';
